import { render, staticRenderFns } from "./SearchResultItemPostAttachments.vue?vue&type=template&id=04abaeb7&scoped=true&"
import script from "./SearchResultItemPostAttachments.vue?vue&type=script&lang=ts&"
export * from "./SearchResultItemPostAttachments.vue?vue&type=script&lang=ts&"
import style0 from "./SearchResultItemPostAttachments.vue?vue&type=style&index=0&id=04abaeb7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04abaeb7",
  null
  
)

export default component.exports